import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Tooltip } from '@mui/material';

import Modal from '../../Modal';
import ActionButton from '../../ActionButton';
import { ReactComponent as FailedIcon } from '../../../assetsNew/icons/failed.svg';
import {
  addBatchMessageStatus,
  closeBatchMessageReport,
  removeBatchMessageStatus
} from '../../../sagas/batchMessage/actions';
import { retrySendbirdBatchMessageRequest } from '../../../sagas/sendbird/batchMessage/retry/actions';
import { batchMessageStatusItem } from '../../../sagas/batchMessage/reducers';

import './_batchMessagesReport.scss';

const BatchMessageReport = () => {
  const dispatch = useDispatch();
  const { report: { open, id, failed_users } } = useSelector(s => s.batchMessage);

  const onClose = () => {
    dispatch(closeBatchMessageReport());
    dispatch(removeBatchMessageStatus({ id }));
  };

  const sendMessage = () => {
    dispatch(retrySendbirdBatchMessageRequest({
      id,
      onSuccess: data => {
        onClose();
        dispatch(addBatchMessageStatus({
          ...batchMessageStatusItem,
          id: data.task_id,
          status: data.status
        }));
      }
    }));
  };

  return (
    <Modal open={open} closeModal={onClose} className="batchMessagesReport-popup">
      <div className="batchMessagesReport-header">
        <p className="batchMessagesReport-title">Report</p>
      </div>
      <div className="batchMessagesReport-container">
        <div className="batchMessagesReport-content">
          <p className="batchMessagesReport-error"><FailedIcon />Failed to send to the following people:</p>
          <div className="batchMessagesReport-users">
            {failed_users.map(user => {
              return (
                <Tooltip key={user.uuid} title={user.name}>
                  <p className="batchMessagesReport-users__item">{user.name}</p>
                </Tooltip>
              );
            })}
          </div>
        </div>
      </div>
      <div className="batchMessagesReport-buttons">
        <ActionButton variant="outlined" title="Cancel" onClick={onClose} />
        <ActionButton title="Try again" onClick={sendMessage} />
      </div>
    </Modal>
  );
};

export default BatchMessageReport;
